import React from "react";
import { Menu, Icon, Image } from "semantic-ui-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../../hooks";
import "./AdminMenu.scss";

export function AdminMenu() {
  const { pathname } = useLocation();
  const { user } = useAuth();

  let role = user?.user?.role;
  if (role === "teacher" && user?.user?.account === "free") {
    role = "teacherfree";
  }

  const isCurrentPath = (path) => pathname === path;

  const roleRoutes = {
    admin: [
      { path: "/portal/users", icon: "user", label: "Usuarios" },
      { path: "/portal/register", icon: "clipboard", label: "Profile" },
      { path: "/portal/institution", icon: "building outline", label: "Institution" },
    ],
    partner: [
      { path: "/portal/partner/register", icon: "clipboard", label: "Info Partner" },
      { path: "/portal/partner/institution", icon: "building outline", label: "Instituciones" },
      { path: "/portal/partner/facturation", icon: "clipboard list", label: "Facturación" },
      { path: "/portal/partner/support", icon: "cogs", label: "Soporte" },
    ],
    institution: [
      { path: "/portal/inst/profile", icon: "university", label: "Institución" },
      { path: "/portal/inst/class", icon: "building", label: "Clases" },
      { path: "/portal/inst/teachers", icon: "user", label: "Docentes" },
      { path: "/portal/inst/students", icon: "graduation cap", label: "Estudiantes" },
      { path: "/portal/inst/support", icon: "cogs", label: "Soporte" },
    ],
    teacher: [
      { path: "/portal/teacher/salas", icon: "window restore", label: "ESCENAS" },
      { path: "/portal/teacher/assistant", icon: "weixin", label: "ASISTENTES IA" },
      { path: "/portal/teacher/quiz", icon: "tasks", label: "EVALUACIONES" },
      { path: "/portal/teacher/evaluacion", icon: "clipboard", label: "ITINERARIOS" },
      { path: "/portal/teacher/educamaker", icon: "sitemap", label: "EDUCAMAKER" },
    ],
    teacherfree: [
      { path: "/portal/teacherfree/salas", icon: "window restore", label: "ESCENAS" },
      { path: "/portal/teacherfree/assistant", icon: "weixin", label: "ASISTENTES IA" },
      { path: "/portal/teacherfree/quiz", icon: "tasks", label: "EVALUACIONES" },
      { path: "/portal/teacherfree/evaluacion", icon: "clipboard", label: "ITINERARIOS" },
      { path: "/portal/teacherfree/educamaker", icon: "sitemap", label: "EDUCAMAKER" },
    ],
    student: [
      { path: "/portal/student/home", icon: "window restore", label: "Contenido" },
    ],
    user: [
      { path: "/portal/userfree/salas", icon: "window restore", label: "Escenas" },
    ],
  };

  const menuItems = roleRoutes[role] || [];

  return (
    <Menu fluid vertical icon text className="admin-menu">
      {menuItems.map((item) => (
        <Menu.Item
          key={item.path}
          as={Link}
          to={item.path}
          active={isCurrentPath(item.path)}
        >
          <Icon name={item.icon} />
          <span className="menu-text">{item.label}</span>
        </Menu.Item>
      ))}

      {(role === "teacher" || role === "teacherfree") && (
        <div className="teacher-card">
          <Image src={user?.user?.avatar || "default-avatar.png"} avatar />
          <div className="teacher-info">
            <p className="teacher-name">{user?.user?.firstname} {user?.user?.lastname}</p>
            <p className="teacher-role">Docente</p>
          </div>
        </div>
      )}

      {role === "user" && (
        <div className="teacher-card">
          <Image src={user?.user?.avatar || "default-avatar.png"} avatar />
          <div className="teacher-info">
            <p className="teacher-name">{user?.user?.firstname} {user?.user?.lastname}</p>
            <p className="teacher-role">Docente</p>
          </div>
        </div>
      )}
    </Menu>
  );
}
